import { docReady } from '../helpers/doc-ready';
docReady(() => {
    const searchaniseMobileToggle = document.querySelectorAll('[data-searchanise-app-mobile-toggle]');
    const searchaniseMobileLauncher = document.querySelector('[data-searchanise-app-mobile-launcher]');
    const searchaniseMobileOverlay = document.querySelector('[data-searchanise-app-mobile-overlay]');
    const searchaniseMobileContainer = document.querySelector('[data-searchanise-app-mobile-container]');
    if (searchaniseMobileToggle && searchaniseMobileLauncher && searchaniseMobileOverlay && searchaniseMobileContainer) {
        searchaniseMobileToggle.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                document.body.classList.toggle('lock');
                searchaniseMobileContainer.classList.toggle('searchanise-app__mobile-container--show');
                searchaniseMobileOverlay.classList.toggle('searchanise-app__mobile-overlay--show');
            });
        });
        searchaniseMobileLauncher.addEventListener('click', () => {
            searchaniseMobileContainer.querySelector('[type="search"]').focus();
        });
    }
    const searchaniseDesktopToggles = document.querySelectorAll('[data-searchanise-app-desktop-toggle]');
    searchaniseDesktopToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const modalInputField = document.querySelector('.searchanise-app__modal input[type="search"]');
            modalInputField.focus();
            document.body.classList.toggle('body--show-searchanise-desktop-modal');
        });
    });
});
